module.exports = __webpack_public_path__ + "img/4.f013b5ae.jpg";